export const DIRECTION = {
  left: 'left',
  right: 'right',
};
